var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
export class PatientLogoutViewModel {
    constructor(container) {
        this.authManager = container.authManager;
    }
    get isLoggedIn() {
        return this.authManager.isLoggedIn;
    }
    get showLoggingOutUI() {
        return this.isLoggedIn;
    }
}
__decorate([
    computed
], PatientLogoutViewModel.prototype, "isLoggedIn", null);
__decorate([
    computed
], PatientLogoutViewModel.prototype, "showLoggingOutUI", null);
